(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reset', {
            parent: 'site',
            url: '/reset',
            data: {
                authorities: [],
                pageTitle: 'Resetowanie hasła - VB Leasing'
            },
            views: {
                'index@': {
                    templateUrl: 'app/views/reset/reset.html',
                    controller: 'ResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
